// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"AreaSearch__searchWrapper__Otu-B","searchbar":"AreaSearch__searchbar__3Qrux","icon":"AreaSearch__icon__2N498","input":"AreaSearch__input__2ieqJ","chip":"AreaSearch__chip__27DiF","closeIcon":"AreaSearch__closeIcon__2Jyip"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/AreaSelection/AreaSearch/AreaSearch.scss
// module id = 1657
// module chunks = 0